import { render, staticRenderFns } from "./TableListHistory.vue?vue&type=template&id=23d36821&scoped=true"
import script from "./TableListHistory.vue?vue&type=script&lang=js"
export * from "./TableListHistory.vue?vue&type=script&lang=js"
import style0 from "./TableListHistory.vue?vue&type=style&index=0&id=23d36821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d36821",
  null
  
)

export default component.exports